import api from "../../../services/apiClient"
import type { ContactFormValues, ContactAlternativeFormValues } from "../models/contact"

const BASE = "contact"

export const contactApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },

  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },

  create: async (values: ContactFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },

  update: async (id: number, values: ContactFormValues) => {
    const { data } = await api.put(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },

  getTypes: async () => {
    const { data } = await api.get(`${BASE}/types`)
    return data?.data ?? data
  },

  createAlternative: async (values: ContactAlternativeFormValues) => {
    const { data } = await api.post(`${BASE}/alternative/create`, values)
    return data?.data ?? data
  },

  updateAlternative: async (id: number, values: ContactAlternativeFormValues) => {
    const { data } = await api.put(`${BASE}/alternative/update/${id}`, values)
    return data?.data ?? data
  },

  deleteAlternative: async (id: number) => {
    const { data } = await api.delete(`${BASE}/alternative/delete/${id}`)
    return data
  },
}
